import * as i0 from '@angular/core';
import { Directive, NgModule } from '@angular/core';

/* tslint:disable */
class PreventAutofocusDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.storedValue = elementRef.nativeElement.tabIndex;
        elementRef.nativeElement.tabIndex = -1;
    }
    ngOnInit() {
        setTimeout(() => {
            if (this.elementRef.nativeElement.tabIndex == -1)
                this.elementRef.nativeElement.tabIndex = this.storedValue;
        }, 1500);
    }
}
PreventAutofocusDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PreventAutofocusDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
PreventAutofocusDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.1.2", type: PreventAutofocusDirective, selector: "[egovPreventAutofocus]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PreventAutofocusDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[egovPreventAutofocus]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class PreventAutofocusModule {
}
PreventAutofocusModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PreventAutofocusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PreventAutofocusModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PreventAutofocusModule, declarations: [PreventAutofocusDirective], exports: [PreventAutofocusDirective] });
PreventAutofocusModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PreventAutofocusModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: PreventAutofocusModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PreventAutofocusDirective],
                    imports: [],
                    exports: [PreventAutofocusDirective]
                }]
        }] });

/*
 * Public API Surface of angular-prevent-autofocus
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PreventAutofocusDirective, PreventAutofocusModule };
